import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ActionBar from "../shared/general/ActionBar";
import RecruiterJobHubTabNavigation from "../TabNavigation/RecruiterJobHubTabNavigation";
import "../general-styles/tab-navigation-styles.scss";
import applicationType from "../Kanban/types/applicationType";
import jobProfileType from "../JobProfile/types/jobProfileType";
import employerProfileType from "../EmployerProfile/types/employerProfileType";
import jobStatusWidgetType from "../JobProfile/types/jobStatusWidgetType";

class RecruiterJobHub extends Component {
  constructor(props) {
    super(props);
    const { jobProfile } = this.props;
    const { jobTitle, location, salaryRange } = jobProfile;
    this.state = {
      actionBarTitle: `${jobTitle} - ${location}, ${salaryRange}`,
      actionBarMobileTitle: jobTitle,
      actionBarSubtitle: `${location}, ${salaryRange}`,
    };
  }

  getActionBarData = (data) => {
    this.setState({
      actionBarTitle: `${data.title} - ${data.subtitle}`,
      actionBarMobileTitle: data.title,
      actionBarSubtitle: data.subtitle,
    });
  };

  render() {
    const {
      jobProfile,
      applications,
      employerProfile,
      isRecruiter,
      cvLimitFull,
      newCandidatesLink,
      submittedCandidates,
      backLinkUrl,
      jobStatusWidget,
      engagementId,
      jobCurrencySymbol,
      jobId,
      showAvgResponseTime,
      isPortalUser,
      recruiterCompanyName,
    } = this.props;

    const { actionBarTitle, actionBarMobileTitle, actionBarSubtitle } =
      this.state;

    return (
      <Fragment>
        <ActionBar
          backLink="Jobs"
          backLinkUrl={backLinkUrl}
          title={actionBarTitle}
          mobileTitle={actionBarMobileTitle}
          subtitle={actionBarSubtitle}
          mobileBackButton
        />
        <div style={{ background: "#e4e5e7" }}>
          <RecruiterJobHubTabNavigation
            applications={applications}
            employerProfile={employerProfile}
            getActionBarData={this.getActionBarData}
            isRecruiter={isRecruiter}
            cvLimitFull={cvLimitFull}
            jobProfile={jobProfile}
            newCandidatesLink={newCandidatesLink}
            submittedCandidates={submittedCandidates}
            jobStatusWidget={jobStatusWidget}
            engagementId={engagementId}
            jobCurrencySymbol={jobCurrencySymbol}
            jobId={jobId}
            showAvgResponseTime={showAvgResponseTime}
            isPortalUser={isPortalUser}
            recruiterCompanyName={recruiterCompanyName}
          />
        </div>
      </Fragment>
    );
  }
}

RecruiterJobHub.propTypes = {
  applications: PropTypes.arrayOf(applicationType).isRequired,
  employerProfile: employerProfileType.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  cvLimitFull: PropTypes.bool.isRequired,
  jobProfile: jobProfileType.isRequired,
  newCandidatesLink: PropTypes.string.isRequired,
  submittedCandidates: PropTypes.string.isRequired,
  backLinkUrl: PropTypes.string,
  jobStatusWidget: jobStatusWidgetType,
  engagementId: PropTypes.number,
  jobCurrencySymbol: PropTypes.string.isRequired,
  jobId: PropTypes.number,
  showAvgResponseTime: PropTypes.bool,
  isPortalUser: PropTypes.bool.isRequired,
  recruiterCompanyName: PropTypes.string.isRequired,
};

RecruiterJobHub.defaultProps = {
  jobStatusWidget: null,
  backLinkUrl: null,
  engagementId: null,
  jobId: null,
  showAvgResponseTime: null,
};

export default RecruiterJobHub;
